
<mat-toolbar color="accent" class="flex justify-between mat-elevation-z6 z-50">
  <!-- Left Header -->
  <div class="flex items-center">
    <button mat-icon-button (click)="onToggleSidenav()" matTooltip="Menu"><mat-icon>menu</mat-icon></button>

    <button mat-button>
      <div class="flex items-center">
        <img src="assets/images/logo.png" alt="Logo" class="w-[36px]" />
        <span>BCTE Portal</span>
      </div>
    </button>
  </div>

  <!-- Right Header-->
  <div class="flex items-center gap-2">
    <!-- Theme toggle -->
    <button mat-icon-button (click)="onToggleTheme()">
      <mat-icon>{{ theme$() === 'light' ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>

    <!-- Notifications -->
    <!-- <app-notification-menu-button></app-notification-menu-button> -->

    <!-- User Menu -->
    <app-user-menu-button></app-user-menu-button>
  </div>
</mat-toolbar>
  
<mat-drawer-container class="h-full" autosize>

  <mat-drawer
    #drawer
    class="min-w-[250px]"
    [mode]="sideNavMode$()"
    [opened]="isSidenavOpen$()"
    (openedChange)="onNavOpenChange($event)"
  >


  
    <div class="flex flex-col justify-between h-full">
      <!-- Menu Options -->
       <div *ngIf="!authServices.isCustomer$()">
      <mat-nav-list>
        @for (item of menuItems; track item.label) {
        <a
          mat-list-item
          routerLinkActive="active"
          [routerLink]="[item.route]"
          [routerLinkActiveOptions]="item.routeOptions || { exact: false }"
          *hasPermission="item.permissions"

        >
          <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
          <h3 matListItemTitle>{{ item.label }}</h3>
        </a>
        }
      </mat-nav-list>
      </div>

      <div *ngIf="!authServices.isCustomer$()">
      <div class="flex flex-col">
        <div class="text-sm text-secondary ml-1">v{{ appVersion }}</div>
        <div class="flex justify-around">
          <a href="https://jira.bcteportal.com/" target="_blank" class="logo bg-card-secondary" matTooltip="Jira">
            <img src="assets/images/jira-logo.png" />
            <div>Jira</div>
          </a>
          <a href="https://confluence.bcteportal.com/" target="_blank" class="logo bg-card-secondary" matTooltip="Confluence">
            <img src="assets/images/confluence-logo.png" />
            <div>Confluence</div>
          </a>
          <a routerLink="/support" class="logo bg-card-secondary" matTooltip="Help Desk">
            <img src="assets/images/jira-service-desk.png" />
            <div>Help Desk</div>
          </a>
        </div>
      </div>
      </div>
    </div>




  </mat-drawer>




  <router-outlet></router-outlet>
</mat-drawer-container>
